'use strict';

$(() => {
    var $topStrip = $('.experience-commerce_assets-shopNote');
    var $body = $('body');
    var $topStripCloseIcon = $topStrip.find('.icon-close');

    if (!sessionStorage.getItem('uniqueSession')) {
        sessionStorage.setItem('uniqueSession', Date.now());
        sessionStorage.setItem('shopNoteClosedAlready', 'false');
    }

    if (sessionStorage.getItem('shopNoteClosedAlready') === 'true') {
        $topStrip.addClass('hide-shop-note');
        $body.addClass('hide-shop-note');
        return;
    }

    let viewPromotionEventData = {
        category: 'promotion',
        event: 'view_promotion',
        name: 'shop Note content',
        reference: 'rKPI_P3.1',
    };

    setTimeout(function () {
        if ($body.find('.shop-note-component-container').hasClass('brand-mtb') && $body.find('.shop-note-component__content-wrapper').children().length > 0) {
            /* eslint-disable prettier/prettier */
            var promotionIDs = $body
                .find(
                    '.shop-note-component-container .shop-note-component__content-wrapper .slick-slide:not(.slick-cloned) .shop-note-content-container .shop-note-content__content-wrapper'
                )
                .map(function () {
                    const promotionId = $(this).data('promotionId');
                    return promotionId ? String(promotionId).trim() : null;
                })
                .get()
                .filter(Boolean)
                .join(',');
            /* eslint-disable prettier/prettier */

            if (promotionIDs) {
                viewPromotionEventData.promotionIDs = promotionIDs;
                if (window.dataLayer) {
                    window.dataLayer.push(viewPromotionEventData);
                }
            }
        }
    }, 1000);

    $topStrip.removeClass('hide-shop-note').addClass('show-shop-note');
    $body.removeClass('hide-shop-note').addClass('show-shop-note');

    if ($('.experience-commerce_assets-shopNoteContent').length > 1) {
        const $shopComponentSlickRegion = $('.shop-note-component__content-region');
        const $shopNoteComponentContentWrapper = $('.shop-note-component__content-wrapper');
        const $animationStyle = $shopNoteComponentContentWrapper.data('animation');
        const $autoScrollSlides = $shopNoteComponentContentWrapper.data('auto-scroll');

        $shopComponentSlickRegion.find('.slick-prev').removeClass('d-none');
        $shopComponentSlickRegion.find('.slick-next').removeClass('d-none');

        const $slickObj = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1000,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
        };

        if ($animationStyle === 'fade-in') {
            $slickObj.fade = true;
            $slickObj.autoplay = true;
            $slickObj.autoplaySpeed = 3000;
            $slickObj.infinite = true;
            $slickObj.pauseOnHover = true;
            $slickObj.pauseOnFocus = true;
            $shopComponentSlickRegion.find('.slick-prev').addClass('d-none');
            $shopComponentSlickRegion.find('.slick-next').addClass('d-none');
        }

        if ($autoScrollSlides === true) {
            $slickObj.autoplay = true;
            $slickObj.autoplaySpeed = 3000;
            $slickObj.infinite = true;
            $slickObj.pauseOnHover = true;
            $slickObj.pauseOnFocus = true;
        }

        if (!$shopComponentSlickRegion.hasClass('slick-initialized')) {
            setTimeout(() => {
                $shopComponentSlickRegion.slick($slickObj);
            }, 100);
        }

        $shopComponentSlickRegion.on('click', '.slick-next', function () {
            $shopComponentSlickRegion.slick('slickNext');
        });

        $shopComponentSlickRegion.on('click', '.slick-prev', function () {
            $shopComponentSlickRegion.slick('slickPrev');
        });
    }

    $topStripCloseIcon.on('click', function () {
        $topStrip.addClass('hide-shop-note').removeClass('show-shop-note');
        $body.addClass('hide-shop-note').removeClass('show-shop-note');
        $body.css('--shop-note-height', '0px');
        $(document).trigger('shopnoteclose');
        sessionStorage.setItem('shopNoteClosedAlready', 'true');
        $('.main-menu, .dropdown-menu, .menu-push-layout-wrapper').css('top', $('.header').outerHeight() + 'px');
    });

    // Product Click Event
    let productClickEventData = {
        category: 'promotion',
        event: 'product_click',
        name: 'shop Note product click',
        reference: 'rKPI_P3.2',
        promotionID: '',
        promotionName: '',
        locationID: 'header',
    };

    setTimeout(function () {
        if ($body.find('.shop-note-component-container').hasClass('brand-mtb') && $body.find('.shop-note-component__content-wrapper').children().length > 0) {
            $body.on(
                'click',
                '.shop-note-component-container .shop-note-component__content-wrapper .slick-slide:not(.slick-cloned) .shop-note-content-container .shop-note-content__content-wrapper .shop-note-content__description.description-mtb.text p a',
                function () {
                    const promotionId = $(this).closest('.shop-note-content__content-wrapper').data('promotionId');
                    const promotionName = $(this).closest('.shop-note-content__content-wrapper').data('promotionName');
                    if (promotionId) {
                        productClickEventData.promotionID = String(promotionId).trim();
                        productClickEventData.promotionName = String(promotionName).trim();
                        sessionStorage.setItem('shopNoteClickedPromotionId', productClickEventData.promotionID);
                        sessionStorage.setItem('shopNoteClickedPromotionName', productClickEventData.promotionName);
                        if (window.dataLayer) {
                            window.dataLayer.push({ ...productClickEventData });
                        }
                    }
                }
            );
        }
    }, 1000);

    // Product Click Event on Page Load (after redirect)
    $(document).ready(function () {
        const promotionId = sessionStorage.getItem('shopNoteClickedPromotionId');
        const promotionName = sessionStorage.getItem('shopNoteClickedPromotionName'); // ← corrected key

        if (promotionId) {
            productClickEventData = {
                category: 'promotion',
                event: 'select_promotion',
                name: 'Promotion Click',
                reference: 'rKPI_P3.2',
                location: 'header',
                promotionID: promotionId,
                promotionName: promotionName,
            };

            if (window.dataLayer) {
                window.dataLayer.push(productClickEventData);
            }

            sessionStorage.removeItem('shopNoteClickedPromotionId');
            sessionStorage.removeItem('shopNoteClickedPromotionName'); // ← corrected key
        }
    });
});
